/* Centralized page identifiers to avoid magic strings in code */
const PAGE_PREFIX = 'page-';

const PAGES = {
	PRODUCTS: 'products',
	PRODUCT: 'product',
	SEARCH: 'search'
};

const PAGE_IDS = {
	PRODUCT: `${PAGE_PREFIX}${PAGES.PRODUCT}`,
	SEARCH: `${PAGE_PREFIX}${PAGES.SEARCH}`
};

module.exports = { PAGES, PAGE_IDS };
